/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";

const QueryList = ({ querySearchResult, queryListIndex }) => {
  return (
    <tr key={queryListIndex}>
      <td>
        <span className="badge badge-info">
          {querySearchResult._id.slice(-7)}
        </span>
      </td>

      <td>
        {moment(querySearchResult?.createdAt).format("DD-MM-YYYY")}
      </td>
      <td>{querySearchResult?.locationName}</td>
      <td className="table-action">
        <span
          className={
            querySearchResult?.queryTypeStatus === "NEW"
              ? "badge badge-info"
              : "badge badge-warning"
          }
        >
          {querySearchResult?.queryTypeStatus}
        </span>
      </td>
      <td className="table-action">
        <span
          className={
            querySearchResult?.queryStatus === "IN-PROGRESS"
              ? "badge badge-info"
              : querySearchResult?.queryStatus === "SOLVED"
              ? "badge badge-success"
              : "badge badge-danger"
          }
        >
          {querySearchResult?.queryStatus}
        </span>
      </td>
      <td>
        <Link
          to={{
            pathname: `/reports/query/query-detail/${querySearchResult._id}`,
            state: querySearchResult
          }}
        >
          {querySearchResult?.queryTitle}
        </Link>
      </td>
      <td>{querySearchResult?.querySubject.substr(0, 75)}</td>
      <td>
        {querySearchResult?.queryCategory} /{" "}
        {querySearchResult.platformType}
      </td>

      <td className="flex-wrap">
        {querySearchResult?.queryScreenshots.map(
          (queryScreenshot, queryScreenshotsIndex) => (
            <strong key={queryScreenshotsIndex}>
              <a
                href={queryScreenshot}
                target="_blank"
                rel="noopener noreferrer"
              >
                Image No {queryScreenshotsIndex + 1},{" "}
              </a>
            </strong>
          )
        )}
      </td>

      <td className="text-center">
        <button>Delete</button>
      </td>
    </tr>
  );
};

QueryList.propTypes = {
  querySearchResult: PropTypes.any,
  queryListIndex: PropTypes.number
};

export default QueryList;
